var collage_event_id = null;
var student_event_id = null;
var current_event = null;
$(document).on('click', '#EventQuotaText', AddEvent);
$(document).on('change', '.CostListItem_File', AddCostImage);
$(document).on('change', '.FileListItem_File', AddFile);
$(document).on('change', '.CostListItem_ExtraFile', AddExtraCostImage);
$(document).on('change', '.CostListItem_UpdateExtraFile', UpdateExtraCostImage);
$(document).on('click', '.ListItem_Lens', ViewImage);
$(document).on('click', '#ViewPayClose', CloseImage);
$(document).on('click', '.ListItem_Print', PrintImageAction);
$(document).on('click', '#DeleteEventButton', DeleteEvent);

$(document).ready(function () {
	GetEventInformation();
});
function GetEventInformation() {
	var DataSend = {
		collage_id: collage_id,
		event_id: event_id
	};
	PostMethodFunctionWhitOutLoader('/API/Collage/Event/GetEventInformation', DataSend, null, ShowEventInformation, null);
}
function ShowEventInformation(response) {
	if (response.status == 0) {
		$('#EventContainer').empty();
		$('#EventContainer').append('<p id="NotFoundEventText" class="Centered">No se encontró el evento</p>');
		return;
	} else {
		current_event = response.event;
		collage_event_id = current_event.id;
		if (current_event.my_event == null && current_event.allow_registration == 0) {
			$('#EventQuotaText').remove();
			$('#EventValue').remove();
			$('#PayMethods').remove();
			$('#PayButton').remove();
		} else {
			$.cookie('event_id', collage_event_id, { expires: 1, path: '/' });
			$.cookie('event_name', current_event.information.name, { expires: 1, path: '/' });
			if (current_event.my_event != null) {
				student_event_id = current_event.my_event.id;
				$('#EventQuotaText').remove();
				$('#PaymentBudgetWarning').text('Los cupos serán reservados única y exclusivamente, al registrase y aprobar su primer pago en la plataforma.');
			} else {
				$('#PayMethods').remove();
				$('#PayButton').remove();
				$('#EventValue').remove();
				$('#PaymentBudgetWarning').text('Los cupos serán reservados única y exclusivamente, al registrase y aprobar su primer pago en la plataforma.');
				if (current_event.quota_limit == true) {
					if (current_event.quota_remainig > 0) {
						$('#EventQuotaText').text('REGISTRARME ' + current_event.quota_remainig + ' Cupo(s) disponibles');
					} else {
						$('#EventContainer').empty();
						$('#EventContainer').append('<p id="NotFoundEventText" class="Centered">Ya no hay cupos disponibles</p>');
						return;
					}
				} else {
					$('#EventQuotaText').text('REGISTRARME');
				}
			}
		}

		current_event.information.start_date = new Date(current_event.information.start_date);
		current_event.information.end_date = new Date(current_event.information.end_date);
		$('#EventTitle').text([current_event.information.name].join(''));
		$('#EventLocation').text([current_event.information.location].join(''));
		if (current_event.information.show_hrs == 0) {
			$('#EventFromDate').append('<strong>Desde: </strong>' + DateTimeToString(current_event.information.start_date, 'd-M-Y'));
			$('#EventToDate').append('<strong>Hasta: </strong>' + DateTimeToString(current_event.information.end_date, 'd-M-Y'));
		} else {
			$('#EventFromDate').append('<strong>Desde: </strong>' + DateTimeToString(current_event.information.start_date, 'd-M-Y H:m') + ' Hrs');
			$('#EventToDate').append('<strong>Hasta: </strong>' + DateTimeToString(current_event.information.end_date, 'd-M-Y H:m') + ' Hrs');
		}
		$('#CollageSchool').text([current_event.collage_school].join(''));
		$('#RepresentName').append('<strong>Nombre encargado: </strong>' + [current_event.represent_name].join(''));
		$('#RepresentEmail').append('<strong>Correo encargado: </strong>' + [current_event.represent_email].join(''));
		$('#RepresentPhone').append('<strong>Teléfono: </strong>' + [current_event.represent_phone].join(''));
		$('#EventValueText').append('<strong>Valor total del evento: $' + current_event.total.toLocaleString() + '</strong><br>' + [current_event.currency].join(''));
		$('#PrincipalEventInformationImage').css('background-image', 'url(/images/event/' + current_event.information.id + '.' + current_event.information.img + currentTimestap + ')');
		GetEventFiles();
		GetEventPayments();

	}
}
function GetEventFiles() {
	var DataSend = {
		student_event_id: student_event_id,
		event_id: collage_event_id
	};
	PostMethodFunctionWhitOutLoader('/API/Collage/Event/GetFiles', DataSend, null, ShowEventFiles, null);
}
function ShowEventFiles(response) {
	$('#FilesList').empty();
	var AppendContent = '';
	$.each(response.files, function (index, file) {
		AppendContent += '<li title="' + file.name + '" class="FilesListItem">';
		if (file.required == 1) {
			AppendContent += ' <p class="FilesListItem_Name" onclick="location.href=\'/Download/Collage/Event/File/' + file.id + '\'">' + file.name + '</p>';
			if (file.student_file != null && file.student_file.img != null) {
				AppendContent += '<p class="FileListItem_FileStateText FileListItem_FileStateText' + file.student_file.state + '">' + file.student_file.state_text + '</p>';
				if (file.student_file.img == 'pdf') {
					AppendContent += '<a href="/Download/Student/Event/File/' + file.student_file.id + currentTimestap + '" class="FileListItem_FileLink"><img src="/images/download_img.png" alt="Descargar"></a>';
				} else {
					AppendContent += '<a href="/Download/Student/Event/File/' + file.student_file.id + currentTimestap + '" class="FileListItem_FileLink"><img src="/images/event/students/files/' + file.student_file.id + '.' + file.student_file.img + currentTimestap + '" alt="Descargar"></a>';
					AppendContent += '<img src="/images/lupa.png" alt="lupa" class="ListItem_Lens">';
					AppendContent += '<img src="/images/imprimir.png" alt="imprimir" class="ListItem_Print"></img>';
				}
			}
			if (current_event.my_event != null && (file.student_file != null && (file.student_file.img == null || file.student_file.state != 1))) {
				AppendContent += '<form class="FilesListItemInput">';
				AppendContent += '<input type="hidden" name="_token" value="' + token + '">';
				AppendContent += '<input type="hidden" name="id" value="' + file.student_file.id + '">';
				AppendContent += '<input type="file" name="file_image" value="" placeholder="" class="FileListItem_File" accept="image/*, application/pdf" />';
				AppendContent += '</form>';
			}
		} else {
			AppendContent += ' <p class="FilesListItem_Name" onclick="location.href=\'/Download/Collage/Event/File/' + file.id + '\'">' + file.name + '</p>';
		}
		AppendContent += '</li>';
	});
	$('#FilesList').append(AppendContent);
}
function GetEventPayments() {
	var DataSend = {
		student_event_id: student_event_id,
		event_id: collage_event_id
	};
	PostMethodFunctionWhitOutLoader('/API/Collage/Event/GetCosts', DataSend, null, ShowEventPayments, null);
}
function ShowEventPayments(response) {
	$('#CostList').empty();
	var AppendContent = '';
	if (student_event_id != null) {
		var payed_counter = 0;
		$.each(response.costs, function (index, cost) {
			if (cost.student_pay && cost.student_pay.state == 1) {
				payed_counter++;
			}
			cost.max_pay_date = new Date(cost.max_pay_date);
			AppendContent += '<li class="CostListItem CostListItemLogin">';
			AppendContent += '<p class="CostListItem_Cost">' + cost.cost_string + ' ' + cost.currency_type + '</p>';
			AppendContent += '<p class="CostListItem_Date">Pagar antes del ' + cost.max_pay_date_text + '</p>';
			if (cost.student_pay.img != null) {
				AppendContent += '<p class="CostListItem_PayStateText CostListItem_PayStateText' + cost.student_pay.state + '">' + cost.student_pay.state_text + '</p>';
				if (cost.student_pay.img == 'pdf') {
					AppendContent += '<a href="/Download/Student/Event/Pay/' + cost.student_pay.id + currentTimestap + '" class="CostListItem_FileLink"><img src="/images/download_img.png" alt="Descargar"></a>';
				} else {
					AppendContent += '<a href="/Download/Student/Event/Pay/' + cost.student_pay.id + currentTimestap + '" class="CostListItem_FileLink"><img src="/images/event/students/pays/' + cost.student_pay.id + '.' + cost.student_pay.img + '?' + currentTimestap + '" alt="Descargar"></a>';
					AppendContent += '<img src="/images/lupa.png" alt="lupa" class="ListItem_Lens">';
					AppendContent += '<img src="/images/imprimir.png" alt="imprimir" class="ListItem_Print"></img>';
				}
			}
			if (cost.student_pay.img == null || cost.student_pay.state != 1) {
				AppendContent += '<form>';
				AppendContent += '<input type="hidden" name="_token" value="' + token + '">';
				AppendContent += '<input type="hidden" name="id" value="' + cost.student_pay.id + '">';
				AppendContent += '<input type="file" name="filePayToUpload" value="" placeholder="" class="CostListItem_File" accept="image/*, application/pdf" />';
				AppendContent += '</form>';
			}
			AppendContent += '</li>';
		});
		$.each(response.extraPays, function (index, cost) {
			AppendContent += '<li class="CostListItem CostListItemLogin">';
			AppendContent += '<p class="CostListItem_PayStateText CostListItem_PayStateText' + cost.state + '">' + cost.state_text + '</p>';
			if (cost.file == 'pdf') {
				AppendContent += '<a href="/Download/Student/Event/Pay/Extra/' + cost.id + currentTimestap + '" class="CostListItem_FileLink"><img src="/images/download_img.png" alt="Descargar"></a>';
			} else {
				AppendContent += '<a href="/Download/Student/Event/Pay/Extra/' + cost.id + currentTimestap + '" class="CostListItem_FileLink"><img src="/images/event/students/extra_pay/' + cost.id + '.' + cost.file + currentTimestap + '" alt="Descargar"></a>';
				AppendContent += '<img src="/images/lupa.png" alt="lupa" class="ListItem_Lens">';
				AppendContent += '<img src="/images/imprimir.png" alt="imprimir" class="ListItem_Print"></img>';
			}
			if (cost.state != 1) {
				AppendContent += '<form>';
				AppendContent += '<input type="hidden" name="_token" value="' + token + '">';
				AppendContent += '<input type="text" placeholder="Describe el pago..." name="TextfilePayToUpload" class="CostListItem_ExtraPayName" value="' + cost.name + '" />';
				AppendContent += '<input type="hidden" name="file_id" value="' + cost.id + '">';
				AppendContent += '<input type="file" name="filePayToUpload" value="" placeholder="" class="CostListItem_UpdateExtraFile" accept="image/*, application/pdf" />';
				AppendContent += '</form>';
			}
			AppendContent += '</li>';
		});
		if (response.extraPays.length < 5) {
			AppendContent += '<li class="CostListItem CostListItemLogin">';
			AppendContent += '<form>';
			AppendContent += '<input type="hidden" name="_token" value="' + token + '">';
			AppendContent += '<input type="text" placeholder="Describe el pago..." name="TextfilePayToUpload" class="CostListItem_ExtraPayName" />';
			AppendContent += '<input type="hidden" name="event_id" value="' + student_event_id + '">';
			AppendContent += '<input type="file" name="filePayToUpload" value="" placeholder="" class="CostListItem_ExtraFile" accept="image/*, application/pdf" />';
			AppendContent += '</form>';
			AppendContent += '</li>';
		}
		var elementExists = document.getElementById("PaymentState");
		if (elementExists) {
			$('#PaymentState').text(current_event.my_event.state_text + ' ' + payed_counter + ' de ' + response.costs.length).attr('class', 'EventState' + current_event.my_event.state);
		} else {
			$('#CollageSchool').before('<p id="PaymentState" class="EventState' + current_event.my_event.state + '">' + current_event.my_event.state_text + ' ' + payed_counter + ' de ' + response.costs.length + '</p>');
		}
		if (payed_counter == 0 && current_event.my_event.state != 1) {
			var elementExists = document.getElementById("DeleteEventButton");
			if (!elementExists) {
				$('#PayMethods').after('<button type="button" id="DeleteEventButton" class="Button">Cancelar inscripción</button>');
			}
		} else {
			$('#DeleteEventButton').remove();
		}
	} else {
		$.each(response.costs, function (index, cost) {
			cost.max_pay_date = new Date(cost.max_pay_date);
			AppendContent += '<li class="CostListItem CostListItemNormal">';
			AppendContent += '<p class="CostListItem_Cost">' + cost.cost_string + ' ' + cost.currency_type + '</p>';
			AppendContent += '<p class="CostListItem_Date">Pagar antes del ' + cost.max_pay_date_text + '</p>';
			AppendContent += '</li>';
		});
	}
	$('#CostList').append(AppendContent);

}
function AddEvent() {
	if (student_id) {
		if (confirm('He leído y acepto los términos y condiciones, así como todas las obligaciones contenidas en la documentación del evento.')) {
			var DataSend = {
				event_id: collage_event_id,
			};
			PostMethodFunction('/Estudiantes/Student/Event/Add', DataSend, null, AddEventSuccesfully, null);
		}
	} else {
		location.href = "/Estudiantes/Registro";
	}
}
function AddEventSuccesfully() {
	location.reload();
}
function AddCostImage() {
	if(checkFileSize($(this))){
		var form = $(this).parent();
		PostMethodMultimediaFunction('/Estudiantes/Student/Event/pay/Add', form, null, GetEventPayments, null);
	}
}
function ViewImage() {
	var img_src = $(this).parent().find('a img').attr('src');
	$('#ViewPayImageContainer').fadeIn(300, function () {
		$('#ViewPayImageContainer img').attr('src', img_src);
		$('#ViewPayImageContainer').slideDown(500);
	});
}
function CloseImage() {
	$('#ViewPayImageContainer').fadeOut(100);
}
function PrintImageAction() {
	var img_src = $(this).parent().find('a img').attr('src');
	PrintImage(img_src, 'Recibo de pago');
}
function AddExtraCostImage() {
	if(checkFileSize($(this))){
		var form = $(this).parent();
		PostMethodMultimediaFunction('/Estudiantes/Student/Event/pay/extra/Add', form, null, GetEventPayments, null);
	}
}
function UpdateExtraCostImage() {
	var form = $(this).parent();
	PostMethodMultimediaFunction('/Estudiantes/Student/Event/pay/extra/Update', form, null, GetEventPayments, null);
}
function AddFile() {
	var form = $(this).parent();
	PostMethodMultimediaFunction('/Estudiantes/Student/Event/file/Add', form, null, GetEventFiles, null);
}
function DeleteEvent() {
	if (confirm('Al cancelar tu inscripción aceptas las condiciones y penalidades.')) {
		var DataSend = {
			event_id: collage_event_id
		};
		PostMethodFunctionWhitOutLoader('/Estudiantes/Student/Event/Delete', DataSend, null, DeleteEventSuccess, null);
	}
}
function DeleteEventSuccess(response) {
	location.reload();
}
